// extracted by mini-css-extract-plugin
export var container = "exercise-post-module--container--3a65d";
export var gridWrapper = "exercise-post-module--gridWrapper--2f33c";